module.exports = __webpack_public_path__ + "static/13-0b0befa11a2321696d1624d951fadd4e.jpg";